import {useTranslations} from 'next-intl';
import Container from '@/container';
import {withBgNeutral200} from '@/hocs/withColors';
import LogosCarousel from '@/ui/logos-carousel';
import styles from './styles.module.scss';

const LOGO_BASE = '/static/images/home/customer-logos';
const Neutral200Div = withBgNeutral200('div');

const CustomerLogosCarousel = () => {
  const t = useTranslations('homepage.customerLogos');
  const logos = t.raw('logos');

  return (
    <Neutral200Div className={styles.strip}>
      <Container>
        <LogosCarousel
          logos={logos}
          logoBase={LOGO_BASE}
          ariaLabel={t('ariaLabel')}
          fadeColor="#f7f5f1"
          muted
        />
      </Container>
    </Neutral200Div>
  );
};

export default CustomerLogosCarousel;
